<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <h1>{{ $t('Documentos Oficiales') }}</h1>
          </v-card-title>
          <v-card-text>
            <oficial-document-table
              :paginationInSearch="true"
              @newDocumentClicked="showOficialDocumentForm = true"
              admin-actions
              v-if="searchConfigReady"
              entity="consultant-document"
              :reload="reload"
              @entitiesloaded="entitiesLoaded()"
              :level="1"
              search-input
              :search-config="searchConfig"
              default-icon="mdi-document"
            ></oficial-document-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="showOficialDocumentForm" max-width="500px">
      <!-- <admin-document-form  @closeDialog="showOficialDocumentForm = false"></admin-document-form> -->

      <!-- <date-menu-form  @created="addDate" @closeForm="dateForm = false" ></date-menu-form> -->
    </v-dialog>
  </div>
</template>

<script>
import apiCtrl from '@/services/api/abstract/abstract-api.js';
import OficialDocumentTable from './OficialDocumentTable.vue';

export default {
  components: {
    OficialDocumentTable,
  },
  data() {
    return {
      searchConfigReady: false,
      searchConfig: {},
      reload: false,
      showOficialDocumentForm: false,
    };
  },
  mounted() {
    this.getConfig();
  },
  methods: {
    getMonthDate(month) {
      return this.year + '-' + month;
    },
    getConfig() {
      this.searchConfigReady = false;
      apiCtrl.get('/config/consultant-document').then(res => {
        console.log(res);
        if (res.data.data.hasOwnProperty('search')) {
          this.searchConfig = res.data.data.search;
        }
        this.searchConfigReady = true;
      });
    },
    entitiesLoaded() {
      console.log('entitiesloaded');
      this.reload = false;
    },
  },
};
</script>
